const entity = 'stakes'
const entitySingle = 'stake'
const tableIcon = 'cil-dollar'

export {
  entity,
  entitySingle,
  tableIcon
}
